import { useState } from "react";

export default function Hero() {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      /* ignore clipboard errors */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-accent-100/70" />
      <div className="pointer-events-none absolute -left-24 top-40 h-80 w-80 rounded-full bg-primary-100/70" />
      <div className="pointer-events-none absolute bottom-0 right-1/4 h-64 w-64 rounded-full bg-secondary-100/60" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 pb-16 pt-28 md:grid-cols-2 md:px-6 md:pb-24 md:pt-36">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm text-secondary-900">
            <span className="h-2 w-2 rounded-full bg-primary-500" />
            原站无法访问时，来此切换镜像继续浏览
          </div>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-foreground-950 md:text-5xl">
            本子网站<span className="text-primary-600">防失联</span>
            <br />
            永久入口导航
          </h1>
          <p className="mt-6 max-w-xl text-base leading-7 text-foreground-600 md:text-lg">
            汇总本子网站全部备用地址与新域名，原站打不开时，换一个镜像继续看。收藏本页，等于给自己留一条不断更的路。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#addresses"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              查看全部备用地址
            </a>
            <button
              type="button"
              onClick={copyLink}
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-100/60 px-6 py-3 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
            >
              {copied ? "链接已复制" : "复制本页链接"}
            </button>
          </div>
          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            <div>
              <p className="font-heading text-2xl text-primary-600">6+</p>
              <p className="mt-1 text-xs text-foreground-600">镜像入口</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-primary-600">7×24</p>
              <p className="mt-1 text-xs text-foreground-600">持续更新</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-primary-600">实时</p>
              <p className="mt-1 text-xs text-foreground-600">状态同步</p>
            </div>
          </div>
        </div>
        <div className="relative hidden md:block">
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20comic%20book%20illustration%2C%20an%20open%20book%20with%20pages%20flowing%20upward%20like%20waves%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20terracotta%20color%20palette%2C%20halftone%20dot%20texture%2C%20minimal%20editorial%20art%2C%20soft%20lighting%2C%20elegant%20and%20clean%20composition&width=1200&height=900&seq=hero-illustration-2026&orientation=landscape"
              alt="本子网站镜像导航的品牌插画，摊开的书本书页如水波般向上流动，暖色简约漫画风格"
              className="h-auto w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 left-5 flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-shield-check-line" />
            </span>
            <div>
              <p className="text-sm font-medium text-foreground-950">全部入口可正常访问</p>
              <p className="text-xs text-foreground-500">最后检测：刚刚</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}